import { __TEST__ } from '../constants'

export const isInExtension = () => Boolean(window.chrome?.runtime?.id)

export function isExtensionSupported() {
  return navigator.userAgent.indexOf('Chrome') !== -1
}

export function getExtensionVersion() {
  if (__TEST__) {
    return null
  }
  /* istanbul ignore next */
  try {
    const manifestData = window.chrome?.runtime?.getManifest?.()
    if (manifestData) return manifestData?.version
    return null
  } catch (e) {
    console.error('Could not detect extension version: ', e)
    return null
  }
}

/* istanbul ignore next */
export async function getContainingUrlFromActiveTab() {
  const tabs = await window.chrome?.tabs?.query({
    active: true,
    currentWindow: true
  })

  if (!tabs?.length || !tabs[0].url) return null

  return tabs[0].url
}
